import React, { Fragment } from 'react';
import { TextInput, required, useTranslate } from 'react-admin';

import { AutocompleteArrayTextInput } from '~/components/ra';
import { isValidEmail } from '~/utils/validateEmail';
import { Role } from '~/types';

import { l } from './RoleShow';

interface Props {
  edit?: boolean;
  role?: Role;
}

const ROLE_ID_PATTERN = /^[a-zA-Z0-9._-]{3,64}$/;

const RoleForm = (props: Props) => {
  const { edit, role } = props;
  const translate = useTranslate();
  const validateId = (value: string): string | undefined =>
    !value || ROLE_ID_PATTERN.test(value) ? undefined : translate(l('idValidation'));
  const validateNotificationEmails = (value?: string[]): string | undefined => {
    const invalidEmails = (value ?? []).filter((email) => !isValidEmail(email));
    if (invalidEmails.length === 0) return undefined;
    return translate(l('notificationEmailsValidation'), {
      smart_count: invalidEmails.length,
      emails: invalidEmails.join(', '),
    });
  };
  return (
    <Fragment>
      {!edit && <TextInput source='id' label={l('id')} validate={[required(), validateId]} />}
      <TextInput source='name' label={l('name')} validate={required()} disabled={role?.readonly} />
      {edit && (
        <AutocompleteArrayTextInput
          source='notificationEmails'
          label={translate(l('notificationEmails'))}
          regularHelperText={translate(l('notificationEmailsHelperText'))}
          validate={validateNotificationEmails}
        />
      )}
    </Fragment>
  );
};

export default RoleForm;
